import script from "./FoodView.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodView.vue?vue&type=script&setup=true&lang=js"

import "./FoodView.vue?vue&type=style&index=0&id=5de8ec84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de8ec84"]])

export default __exports__